import { NamedNode } from '@ontologies/core';
import * as schema from '@ontologies/schema';
import { t } from 'i18next';
import { SomeNode } from 'link-lib';
import { useIds, useLRS } from 'link-redux';
import React, {
  FC,
  MouseEventHandler,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import teamGL from '../../../ontology/teamGL';
import TableFrame, { Column } from '../../components/Collection/Frame/TableFrame';
import { useCurrentActor } from '../../hooks/useCurrentActor';
import {
  ShowDialog,
  StartSignIn,
} from '../../middleware/actions';
import app from '../../../ontology/app';

import AddressBulkForm from './AddressBulkForm';

const AddressContext = createContext<{
  bulkEnabled: boolean;
  selected: SomeNode[];
  toggle: (subject: SomeNode) => void;
    }>({} as any);

const columns: Column[] = [
  {
    label: t('table.addresses.columns.address'),
    property: schema.name,
    render: ({ subject, term }) => {
      const { bulkEnabled, selected, toggle } = useContext(AddressContext);

      const handleClick: MouseEventHandler = (e) => {
        e.stopPropagation();
        toggle(subject);
      };

      return (
        <React.Fragment>
          {bulkEnabled && (
            <Checkbox
              checked={selected.includes(subject)}
              color="primary"
              sx={{
                padding: 0,
                paddingRight: 3,
              }}
              onClick={handleClick}
            />
          )}
          {term.value}
        </React.Fragment>
      );
    },
    sortProperty: teamGL.number,
  },
];
const ACTION_ID = app.ns('visits/bulk');

const AddressTable: FC = () => {
  const lrs = useLRS();
  const { actorType } = useCurrentActor();
  const [bulkEnabled, setBulkEnabled] = useState(false);
  const [selected, setSelected] = useState<SomeNode[]>([]);
  const value = useMemo(() => ({
    bulkEnabled,
    selected,
    toggle: (subject: SomeNode) => setSelected((prev) => {
      if (prev.includes(subject)) {
        return prev.filter((val) => val !== subject);
      }

      return [...prev, subject];
    }),
  }), [selected, bulkEnabled]);
  const [bulkEntrypoint] = useIds(ACTION_ID, schema.target);

  const onRowClick = (subject: SomeNode) => {
    if (bulkEnabled) {
      value.toggle(subject);
    } else {
      if (actorType === 'GuestUser') {
        lrs.actions.get(StartSignIn)(subject as NamedNode);
      } else {
        lrs.actions.get(ShowDialog)(subject);
      }
    }
  };

  return (
    <AddressContext.Provider
      value={value}
    >
      <TableFrame
        columns={columns}
        headerButtons={(
          <FormControlLabel
            control={(
              <Checkbox
                checked={bulkEnabled}
                color="primary"
                onClick={() => setBulkEnabled(!bulkEnabled)}
              />
            )}
            label="Selecteer meerdere"
          />
        )}
        onRowClick={onRowClick}
      />
      {selected.length > 0 && bulkEntrypoint && bulkEnabled && (
        <AddressBulkForm
          entrypoint={bulkEntrypoint}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </AddressContext.Provider>
  );
};

export default AddressTable;
